export default __webpack_public_path__ + "static/media/2.5241192b.JPG";